























import Vue from 'vue';
import type { PropOptions } from 'vue';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import { ONBOARDING_STEP_COUNT } from '@/components/partials/war-room-onboarding/constants';

export default Vue.extend({
  name: 'WarRoomOnboardingFooter',
  components: {
    BravadoButtonV3,
  },
  props: {
    step: {
      type: Number,
      default: null,
      required: true,
    } as PropOptions<number>,
    stepCount: {
      type: Number,
      default: ONBOARDING_STEP_COUNT,
    } as PropOptions<number>,
    backButtonLabel: {
      type: String,
      default: 'Back',
    } as PropOptions<string>,
    hasBackButton: {
      type: Boolean,
      default: false,
    },
    disableBackButton: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
  },
  computed: {
    nextButtonName() {
      if (this.step === this.stepCount) return 'Finish';

      return 'Continue';
    },
  },
});
